import styled from 'styled-components';

export const MaxSpacing = styled.div`
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  flex-grow: 1;
`;
